import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { getThemeWithLocale } from './theme';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import './i18n';
import './index.css';
import App from './App';

function LocalizedApp() {
  const { currentLanguage } = useAuth();
  const theme = useMemo(() => getThemeWithLocale(currentLanguage), [currentLanguage]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <App />
      </ToastProvider>
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <LocalizedApp />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);